<script lang="ts">
import { Component, Mixins, Model, Prop } from 'vue-property-decorator'
import BaseButton from '@/components/BaseButton.vue'
import { TransportInfoKey, TransportType } from '@/utilities'
import { AppBase, StoreMixin } from '@/mixins'
import { StorageService } from '@/services'
import { IChecklist } from '@/models/common'

/**
 * 画面仕様書
 *
 * 機能名　  : 経路検索機能
 * 画面ＩＤ  : MRO-0031
 * 画面名　  : 交通手段選択ダイアログ
 * 概要　　  : 交通手段を選択するダイアログ
 */
@Component({
  components: {
    BaseButton,
  },
})
export default class MRO_0031 extends Mixins(AppBase, StoreMixin) {
  private transportationSelect: string[] = []
  @Model() dialogTransportation: boolean = false
  @Prop() systemTransportList!: string[]

  constructor() {
    super()
  }

  mounted() {
    this.availableTransportList.forEach((transport) => {
      const checkTransportValue = StorageService.getTransportConditionByKey(
        transport.value.toString()
      )
      if (checkTransportValue) {
        this.transportationSelect.push(transport.value.toString())
      }
    })
  }

  sortTransportList(transportList: IChecklist[]) {
    const SORTED = [TransportInfoKey.PLANE, TransportInfoKey.BULLETTRAIN, TransportInfoKey.LIMITEDEXPRESS, TransportInfoKey.CAR, TransportInfoKey.BUS, TransportInfoKey.SHIP, TransportInfoKey.CYCLE]
    const result = SORTED
      .map(transportValue => {
        const found = transportList.find(item => item.value === transportValue)
        if (found) return found
      })
      .filter(item => !!item)
    return result as IChecklist[]
  }

  get availableTransportList(): IChecklist[] {
    let availableTransportList: IChecklist[] = []
    this.systemTransportList.forEach((systemTransport) => {
      var item = this.TRANSPORT_LIST.find(
        (item) => item.value === TransportInfoKey[systemTransport]
      )
      if (item) {
        availableTransportList.push(item)
      }
    })
    return this.sortTransportList(availableTransportList)
  }

  get TRANSPORT_LIST(): IChecklist[] {
    return [
      {
        label: this.$t('MRO-0031.100'),
        value: TransportType.plane,
      },
      {
        label: this.$t('MRO-0031.101'),
        value: TransportType.bullettrain,
      },
      {
        label: this.$t('MRO-0031.102'),
        value: TransportType.limitedexpress,
      },
      {
        label: this.$t('MRO-0031.103'),
        value: TransportType.car,
      },
      {
        label: this.$t('MRO-0031.104'),
        value: TransportType.bus,
      },
      {
        label: this.$t('MRO-0031.105'),
        value: TransportType.ship,
      },
      {
        label: this.$t('MRO-0031.106'),
        value: TransportType.cycle,
      },
    ]
  }

  handleTransportationClick() {
    this.availableTransportList.forEach((transport) => {
      if (this.transportationSelect.includes(transport.value.toString())) {
        StorageService.setTransportConditionByKey(transport.value.toString(), true)
      } else {
        StorageService.setTransportConditionByKey(transport.value.toString(), false)
      }
    })
    this.$emit('close-popup')
  }
}
</script>

<template>
  <v-dialog
    id="mro-0031"
    v-model="dialogTransportation"
    scrollable
    max-width="300px"
    persistent
  >
    <v-card>
      <v-card-title class="dialog pb-3">{{ $t('MRO-0031.001') }}</v-card-title>
      <v-card-text>
        <v-divider class="solid-top"></v-divider>
        <v-container class="pa-0">
          <v-checkbox
            hide-details
            v-for="(transportation) in availableTransportList"
            v-model="transportationSelect"
            :label="transportation.label"
            :value="transportation.value"
            color="primary"
            :key="transportation.value"
          ></v-checkbox>
        </v-container>
      </v-card-text>
      <v-card-actions class="pa-0">
        <base-button class="button-ok" @click="handleTransportationClick" block>
          {{ $t('MRO-0030.003') }}
        </base-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.button-ok {
  border-radius: 0;
}
</style>
